var minimodal = require('minimodal');

var targets = document.querySelectorAll('[data-minimodal]');
for (var i = 0; i < targets.length; i += 1) {
  var modal = minimodal(targets[i], {
    previousButtonHTML: '<',
    nextButtonHTML: '>',
    closeButtonHTML: '&times;'
  });
  modal.init();
}
